export const defaultList = {
    totalCount: 0,
    entities: [],
};

export const sizePerPageList = [
    {text: "10", value: 10},
    {text: "50", value: 50},
    {text: "100", value: 100},
];

export const defaultUser = {
    id: "",
    name: "",
    phone: "",
    password: "",
    active: true,
    role: "",
    dashboardType: {id: "NO_DASHBOARD", name: "No Dashboard"},
};

export const defaultOrg = {
    name: "",
    phone: "",
    active: true,
    address: "",
    city: "",
    pinCode: "",
    adminUserName: "",
    adminPassword: "",
    adminPasswordConfirm: "",
};

export const defaultDesignation = {
    id: "",
    name: "",
};

export const defaultWorker = {
    id: "",
    name: "",
    phone: "",
    address: "",
    pan: "",
    aadhar: "",
    bankAccountUserName: "",
    ifscCode: "",
    bankAccountNumber: "",
    bankBranch: "",
    userActive: true,
};

export const defaultDealer = {
    id: "",
    name: "",
    brand: "",
    address: "",
    operatingCity: "",
    gstNumber: "",
};

export const defaultBranch = {
    id: "",
    name: "",
    dealerId: "",
    managerId: "",
    supervisorId: [],
};

export const defaultAttendance = {
    id: "",
    branchId: "",
    workerId: "",
    attendanceDate: new Date(),
    supervisorId: "",
};

export const defaultVehicleModel = {
    id: "",
    oem: "",
    model: "",
    vehicleSegment: "",
};

export const defaultTreatment = {
    id: "",
    name: "",
    description: "",
    hsnNumber: "",
    dealerId: "",
    category: "HVT",
    pricingType: "SEGMENT_PRICING",
    pricing: [],
    isVAS: true,
};

export const defaultJobCard = {
    id: "",
    branchId: "",
    vehicleNo: "",
    vehicleModelId: "",
    roNumber: "",
    jobType: "PAID_SERVICE",
    status: "OPEN",
    selectedTreatments: [],
    deletedTreatments: [],
    advisorId: "",
    committedDate: new Date(),
    startDate: new Date(),
    endDate: null
};

export const defaultPassword = {
    password: "",
    confirmPassword: "",
};

export const defaultRole = {
    id: "",
    name: "",
    description: "",
    allowedPermissions: [],
};

